import { mapState, mapMutations, mapGetters, mapActions } from 'vuex';
import search from '@components/ui-components/search/component';

export default {
    data() {
        return {
            menuDecision: -1,
            openClasses: -1,
            openMenuDir: -1,
        };
    },
    components: {
        'search-cmp': search,
    },
    computed: {
        ...mapState('mobile', ['isTabletMenuVisible', 'isTablet', 'isTabletHeader']),
        ...mapGetters('lk', ['isAuth', 'linkLogout']),
    },
    watch: {
        'isTabletMenuVisible': function() {
            if (!this.isMobileMenuVisible) {
                this.menuDecision = -1;
                this.openClasses = -1;
            }
        }
    },
    methods: {
        ...mapGetters('mobile', ['isVisibleSubmenu']),
        ...mapMutations('mobile', ['setActiveTabletSubmenuIndex']),
        // ...mapActions('lk', ['logOut']),
        openMenuDes(key, index) {
            this.menuDecision = parseInt(key, 10);
            this.openClasses = -1;
            this.openMenuDir = index;
        },
        toPage(link) {
            this.menuDecision = -1;
            this.$router.push(link);
        },
    },
};



// WEBPACK FOOTER //
// ./src/templates/components/tablet-menu/component.js